import { Box } from '@mui/material'
import { mapLoader } from 'components/domain/GoogleMaps'
import type React from 'react'
import { useEffect } from 'react'

const PaymentLocationMap: React.FC = () => {
    useEffect(() => {
        mapLoader.importLibrary('maps').then(({ Map, InfoWindow }) => {
            const map = new Map(document.getElementById('map') as HTMLElement, {
                center: { lat: 33.9140327, lng: -117.2653872 },
                zoom: 12,
                mapId: 'DEMO_MAP_ID',
                streetViewControl: false,
                mapTypeControl: false
            })
            const infoWindowContent = `
                <div>
                    <div style="display: flex; justify-content: space-between; width: 100%">
                        <div style="text-align: left; width: 75%">
                            <div><b>Moreno Valley Electrical Utility</b></div>
                            <div>14331 Frederick ST, Suite 2, Moreno Valley, CA 92552</div>
                            <div>Monday - Thursday 7:30AM - 5:30PM</div>
                            <div>Friday 8:00AM - 5:00PM</div>
                            <div>(844) 425-0855</div>
                            <a href="https://maps.app.goo.gl/JDh4hrYf7Rg8rLzw6"
                            target="_blank"
                            rel="noreferrer"
                        >
                            View larger map
                        </a>
                        </div>
                        <div style="text-align: right; width: 25%">
                            <a style="color: #3a84df; display: block; height: 43px; text-decoration: none; width: 54.7344px" target="_blank" href="https://www.google.com/maps/dir//14331+Frederick+St+%232,+Moreno+Valley,+CA+92553/@33.9141352,-117.2641263,936m/data=!3m1!1e3!4m17!1m7!3m6!1s0x80dca67381cdfa3b:0x6b4f599d21fa0f94!2s14331+Frederick+St+%232,+Moreno+Valley,+CA+92553!3b1!8m2!3d33.9141308!4d-117.2615514!4m8!1m0!1m5!1m1!1s0x80dca67381cdfa3b:0x6b4f599d21fa0f94!2m2!1d-117.2615514!2d33.9141308!3e3?entry=ttu&g_ep=EgoyMDI2MDIwNC4wIKXMDSoASAFQAw%3D%3D" rel="noreferrer">
                            <div style="background: rgba(0, 0, 0, 0) url(https://maps.gstatic.com/mapfiles/embed/images/entity11.png) no-repeat; height: 22px; width: 22px; margin-right: auto; margin-left: auto"></div>    
                            Directions
                            </a>
                        </div>
                    </div>
                </div>
            `
            const infoWindow = new InfoWindow({
                content: infoWindowContent,
                disableAutoPan: true
            })
            mapLoader.importLibrary('marker').then(({ AdvancedMarkerElement }) => {
                const marker = new AdvancedMarkerElement({
                    map,
                    position: { lat: 33.9140327, lng: -117.2653872 },
                    title: 'Moreno Valley Electrical Utility'
                })
                infoWindow.open(map, marker)
                return marker
            }).catch((e) => { console.log(e) })
        }).catch((e) => { console.log(e) })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Box id="map" flex={1} />
    )
}

export default PaymentLocationMap
